export default [
    {
        "sayfa_adi": "ANASAYFA",
        "path": "/",
        "title": "Canlı İddaa | Spor Toto | Oley.com",
        "description": "Yasal Bahsin Adresi Oley.com Canlı iddaa, canlı bahis, canlı skorlar, sosyoley, canlı maç izle ve daha fazlası, hemen kazanmaya başla! ",
    },
    {
        "sayfa_adi": "BÜLTEN",
        "path": "/iddaa/futbol/tumu",
        "title": "İddaa Programı | İddaa Bülteni | Oley.com",
        "description": "Oley.com'da heyecan yüksek! Canlı iddaa oyna, güncel maç programını hemen incele, favori liglerine bahis yap, kazanmanın heyecanına ortak ol!",
    },
    {
        "sayfa_adi": "SOSYOLEY",
        "path": "/sosyoley/anasayfa/kuponlarim/",
        "title": "Sosyoley | Kupon Paylaş, İddaa Oyna | Oley.com",
        "description": "Kupon paylaşım platformu Sosyoley’de diğer oyuncuların iddaa kuponlarını gör, kendi kuponunu paylaş, favorilerini takip et. Kazanmanın sosyal hali Sosyoley!",
    },
    {
        "sayfa_adi": "CANLI SKORLAR",
        "path": "/canli-skorlar",
        "title": "Canlı Skorlar | Canlı İddaa Oyna | Oley.com",
        "description": "Canlı maç sonuçları, anlık skorlar ve canlı iddaa programı bahsin adresi Oley.com'da, hemen kuponunu yap kazanmaya başla!",
    },
    {
        "sayfa_adi": "SOSYOLEY / ZİRVEDEKİLER",
        "path": "/sosyoley/zirvedekiler",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "ŞANS OYUNLARI",
        "path": "/sans-oyunlari/",
        "title": "Şans Oyunları | Oley.com",
        "description": "Zeplin, çarkıfelek, eşya piyangosu, mayın tarlası ve daha fazlası yasal bahsin adresi Oley.com'da. Hemen oyna, heyecan dolu anlar yaşa!",
    },
    {
        "sayfa_adi": "SPOR TOTO",
        "path": "/spor-toto/oyna",
        "title": "Spor Toto Oyna | Oley.com",
        "description": "Spor Toto heyecanı Oley.com'da, güncel Spor Toto programını takip et, hemen oyna. ",
    },
    {
        "sayfa_adi": "YARDIM",
        "path": "/yardim/uyelik",
        "title": "Yardım | Sık Sorulan Sorular | Oley.com",
        "description": "Üyelik, para işlemleri ve daha fazlası için yardım sayfamızdan detaylı bilgilere ulaşabilir, 7/24 çağrı merkezimizi arayabilirsiniz. ",
    },
    {
        "sayfa_adi": "ÜYE OL",
        "path": "/uye-ol",
        "title": "Hemen Üye Ol | Canlı İddaa Oyna | Oley.com ",
        "description": "Kolay üyelik ve hızlı giriş! Oley.com'a hemen üye ol! Binlerce lige yüzlerce maça canlı iddaa oyna, kazanmanın heyecanını zirvede yaşa!",
    },
    {
        "sayfa_adi": "ÜYE OL",
        "path": "/kayit",
        "title": "Hemen Üye Ol | Canlı İddaa Oyna | Oley.com ",
        "description": "Kolay üyelik ve hızlı giriş! Oley.com'a hemen üye ol! Binlerce lige yüzlerce maça canlı iddaa oyna, kazanmanın heyecanını zirvede yaşa!",
    },
    {
        "sayfa_adi": "PARA YATIRMA",
        "path": "/yardim/para-yatirma",
        "title": "Yardım | Para Yatırma | Oley.com",
        "description": "Oley hesabına hızlı ve güvenli şekilde para yatır! Çeşitli ödeme yöntemleriyle kolayca yatırım yap, bahis heyecanına ortak ol!",
    },
    {
        "sayfa_adi": "PARA ÇEKME",
        "path": "/yardim/para-cekme",
        "title": "Yardım | Para Çekme | Oley.com ",
        "description": "Para çekme işlemleri Oley.com'da sorunsuz ve güvenli. Hızlı işlem süreleri ve 7/24 müşteri desteğiyle güvenli bahis yapın!",
    },
    {
        "sayfa_adi": "KUPONLARIM",
        "path": "/hesabim/iddaa/devam-edenler",
        "title": "Kuponlarım | İddaa Kuponlarım | Oley.com",
        "description": "Oynadığın tüm iddaa kuponlarını anlık takip et, durumlarını incele.",
    },
    {
        "sayfa_adi": "KAMPANYALAR",
        "path": "/kampanyalar",
        "title": "Yasal Bahsin Adresi | Oley.com",
        "description": "Yüzlerce lige canlı iddaa oyna, kazanmanın heyacanını Oley.com'da yaşa!",
    },
    {
        "sayfa_adi": "BASKETBOL",
        "path": "/iddaa/basketbol/tumu",
        "title": "Basketbol | İddaa Oyna | Oley.com",
        "description": "NBA, EuroLeague ve Türkiye Basketbol Ligi iddaa programını takip et, canlı iddaa oyna!",
    },
    {
        "sayfa_adi": "FUTBOL",
        "path": "/iddaa/futbol/tumu",
        "title": "Futbol İddaa Programı | İddaa Oyna | Oley.com",
        "description": "Süper Lig’den Premier Lig’e, Şampiyonlar Ligi ve Avrupa’nın dev karşılaşmalarına hemen canlı iddaa oyna! Futbol tutkunu kazanca dönüştür!",
    },
    {
        "sayfa_adi": "TENİS",
        "path": "/iddaa/tenis/tumu",
        "title": "Tenis İddaa Programı | İddaa Oyna | Oley.com",
        "description": "ATP, WTA ve Grand Slam Karşılaşmaları, Wimbledon, Roland Garros ve daha fazlası... En prestijli tenis turnuvaları ve anlık oranlarla tenis heyecanı Oley’de!",
    },
    {
        "sayfa_adi": "VOLEYBOL",
        "path": "/iddaa/voleybol/tumu",
        "title": "Voleybol İddaa Oyna | İddaa Programı | Oley.com",
        "description": "File üstü mücadelelerin heyecanı Oley’de! Voleybol maçlarını takip et, iddaa kuponunu oluştur, kazancını katla!",
    },
    {
        "sayfa_adi": "CANLI BAHİS",
        "path": "/iddaa/canli/futbol",
        "title": "Canlı İddaa | Canlı Bahis | Oley.com",
        "description": "Canlı iddaa oyna, canlı skorları anlık takip et kazanmanın heyecanını bahsin adresi Oley.com'da yaşa!",
    },
    {
        "sayfa_adi": "GİRİŞ YAP",
        "path": "/giris-yap",
        "title": "Giriş Yap | Hemen Oyna | Oley.com",
        "description": "Hesabına hızlı ve güvenli şekilde giriş yap, hemen oyna kazanmaya başla!",
    },
    {
        "sayfa_adi": "DUYURULAR",
        "path": "/duyurular",
        "title": "Güncel Duyurular | Bilgilendirmeler | Oley.com",
        "description": "Güncel duyurular ve sistem güncellemelerini takip edin. ",
    },
    {
        "sayfa_adi": "SORUMLU BAHİS",
        "path": "/sozlesmeler/sorumlu-bahis",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "ÇEREZ POLİTİKASI",
        "path": "/sozlesmeler/cerez-politikas",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "KVKK POLİTİKASI",
        "path": "/sozlesmeler/kvkk-politikas",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "TİCARİ ELEKTRONİK İLETİ GÖNDERİLMESİNE İLİŞKİN AYDINLATMA METNİ",
        "path": "/sozlesmeler/ticari-elektronik-ileti-gonderilmesine-iliskin-aydnlatma-metni",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "ÜYE AYDINLATMA METNİ",
        "path": "/sozlesmeler/uye-aydnlatma-metni",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "KULLANICI SÖZLEŞMESİ",
        "path": "/sozlesmeler/kullanc-sozlesmesi",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "SOSYOLEY / EN POPÜLER KUPONLAR",
        "path": "/sosyoley/en-populer-kuponlar",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "SOSYOLEY / ZAMAN TÜNELİ",
        "path": "/sosyoley/zaman-tuneli/kuponlarim",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "SOSYOLEY / TAKİP ETTİKLERİMİN PAYLAŞIMLARI",
        "path": "/sosyoley/takip-ettiklerimin-paylasimlari",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "SOSYOLEY / PROFİLİM",
        "path": "/sosyoley/profilim",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "SOSYOLEY / YAZARLAR",
        "path": "/sosyoley/yazarlar",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "SOSYOLEY / SOSYOLEYCİLER",
        "path": "/sosyoley/sosyoleyciler",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "ŞANS OYUNLARI / ALTIN ÇARK",
        "path": "/sans-oyunlari/altincark",
        "yeni_url": "/sans-oyunlari/altin-cark",
        "oneri_notu": "Bitişik yazım okunabilirliği zorlaştırır. SEO'da kelime arası tire kullanımı önerilir.",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "ŞANS OYUNLARI / ZEPLİN",
        "path": "/sans-oyunlari/zeplin",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "ŞANS OYUNLARI / SÜPER ÇARKI FELEK",
        "path": "/sans-oyunlari/carkifelek",
        "yeni_url": "/sans-oyunlari/super-carkifelek",
        "oneri_notu": "Sayfa adı ile URL’deki kelime dizilimi ve yazım formu birebir olmalı.",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "ŞANS OYUNLARI / KAZANDIRAN BALONLAR",
        "path": "/sans-oyunlari/kazandiranbalonlar",
        "yeni_url": "/sans-oyunlari/kazandiran-balonlar",
        "oneri_notu": "Bitişik yazım okunabilirliği zorlaştırır. SEO'da kelime arası tire kullanımı önerilir.",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "ŞANS OYUNLARI / MAYIN TARLASI",
        "path": "/sans-oyunlari/mines",
        "yeni_url": "/sans-oyunlari/mayin-tarlasi",
        "oneri_notu": "Bitişik yazım okunabilirliği zorlaştırır. SEO'da kelime arası tire kullanımı önerilir.",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "ŞANS OYUNLARI / PLINKO",
        "path": "/sans-oyunlari/plinko",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "ŞANS OYUNLARI / TAŞ, KAĞIT, MAKAS",
        "path": "/sans-oyunlari/taskagitmakas",
        "yeni_url": "/sans-oyunlari/tas-kagit-makas",
        "oneri_notu": "Bitişik yazım okunabilirliği zorlaştırır. SEO'da kelime arası tire kullanımı önerilir.",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "ŞANS OYUNLARI / OYNA KAZAN",
        "path": "/oyna-kazan",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "ŞANS OYUNLARI / EŞYA PİYANGOSU",
        "path": "/esya-piyangosu",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "UZUN VADELİ BAHİSLER",
        "path": "/iddaa/futbol/uzunvadeli",
        "yeni_url": "/iddaa/futbol/uzun-vadeli",
        "oneri_notu": "-",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "SPOR TOTO SONUÇLARI",
        "path": "/spor-toto/sonuclar",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "BANKA HESAPLARIM",
        "path": "/hesabim/banka-hesaplarim",
        "title": "Banka Hesaplarım | Oley.com",
        "description": "Banka hesaplarınızı güvenle ekleyip düzenleyebilirsiniz.",
    },
    {
        "sayfa_adi": "YARDIM / ÜYELİK",
        "path": "/yardim/uyelik",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "YARDIM / İDDAA",
        "path": "/yardim/iddaa",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "HAKKIMIZDA",
        "path": "/hakkimizda",
        "title": "Şirketimiz | Hakkımızda | Oley.com",
        "description": "Şirketimiz hakkında daha detaylı bilgilere bu sayfadan ulaşabilir, Oley.com hakkında daha fazla bilgi edinebilirsiniz.",
    },
    {
        "sayfa_adi": "ÜYELİK SÖZLEŞMESİ",
        "path": "/uyelik-sozlesmesi",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "İLETİŞİM",
        "path": "/iletisim",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "BİZE YAZIN",
        "path": "/bize-yazin",
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "SNOOKER",
        "path": "/iddaa/snooker/tumu",
        "yeni_url": "/iddaa/snooker",
        "oneri_notu": null,
        "title": null,
        "description": null,
    },
    {
        "sayfa_adi": "E-FUTBOL",
        "path": "/iddaa/esoccer/tumu",
        "yeni_url": "/iddaa/e-futbol",
        "oneri_notu": "sayfa adı Türkçe → URL de Türkçe olmalı.",
        "title": "E-Futbol İddaa Programı | İddaa Oyna | Oley.com",
        "description": "E-Futbol ile iddaa heyecanı bambaşka! Detaylı istatistikler ile hemen iddaa oyna, maçları canlı izle! Bahsin adresi Oley.com",
    },
    {
        "sayfa_adi": "SÜPER TOMBALA",
        "path": "/sans-oyunlari/supertombala",
        "yeni_url": "/sans-oyunlari/super-tombala",
        "oneri_notu": "Bitişik yazım okunabilirliği zorlaştırır. SEO'da kelime arası tire kullanımı önerilir.",
        "title": "Süper Tombala | Şans Oyunları | Oley.com",
        "description": "Süper Tombala ile büyük heyecan başlasın! Oley.com'da hemen oyna! ",
    },
    {
        "sayfa_adi": "HIZLI TOMBALA",
        "path": "/sans-oyunlari/hizlitombala",
        "yeni_url": "/sans-oyunlari/hizli-tombala",
        "oneri_notu": "Bitişik yazım okunabilirliği zorlaştırır. SEO'da kelime arası tire kullanımı önerilir.",
        "title": "Hızlı Tombala | Şans Oyunları | Oley.com",
        "description": "Hızlı Tombala ile tempoyu artır! Kısa sürede daha fazla heyecan ve kazanma şansı seni bekliyor.",
    },
    {
        "sayfa_adi": "BÜYÜLÜ KAPADOKYA",
        "path": "/sans-oyunlari/buyulukapadokya",
        "yeni_url": "/sans-oyunlari/buyulu-kapadokya",
        "oneri_notu": "Bitişik yazım okunabilirliği zorlaştırır. SEO'da kelime arası tire kullanımı önerilir.",
        "title": "Büyülü Kapadokya | Şans Oyunları | Oley.com",
        "description": "Büyülü Kapadokya’da şans dolu bir yolculuğa çık! Oley.com'da hemen oyna!",
    },
    {
        "sayfa_adi": "MEGA BALON",
        "path": "/sans-oyunlari/megabalon",
        "yeni_url": "/sans-oyunlari/mega-balon",
        "oneri_notu": "Bitişik yazım okunabilirliği zorlaştırır. SEO'da kelime arası tire kullanımı önerilir.",
        "title": "Mega Balon | Şans Oyunları | Oley.com",
        "description": "Mega Balon ile heyecan zirvede! Oley.com'a üye ol, hemen oyna!",
    },
    {
        "sayfa_adi": "YILDIZ TOPÇU",
        "path": "/sans-oyunlari/yildiztopcu",
        "yeni_url": "/sans-oyunlari/yildiz-topcu",
        "oneri_notu": "Bitişik yazım okunabilirliği zorlaştırır. SEO'da kelime arası tire kullanımı önerilir.",
        "title": "Yıldız Topçu | Şans Oyunları | Oley.com",
        "description": "Yıldız Topçu ile hedefi vur, şansını artır! Eğlenceli ve kazandıran şans oyunları Oley’de seni bekliyor.",
    },
    {
        "sayfa_adi": "ŞANSLI EŞLEŞME",
        "path": "/sans-oyunlari/sanslieslesme",
        "yeni_url": "/sans-oyunlari/sansli-eslesme",
        "oneri_notu": "Bitişik yazım okunabilirliği zorlaştırır. SEO'da kelime arası tire kullanımı önerilir.",
        "title": "Şanslı Eşleşme | Şans Oyunları | Oley.com",
        "description": "Şanslı Eşleşme ile doğru kombinasyonu yakala! Eğlenceli şans oyunu Oley’de seni bekliyor, hemen üye ol!",
    },
    {
        "sayfa_adi": "MMA",
        "path": "/iddaa/mma/tumu",
        "yeni_url": "/iddaa/mma",
        "oneri_notu": "-",
        "title": "MMA İddaa | Dövüş Sporları İddaa | Oley.com",
        "description": "MMA iddaa heyecanı Oley’de! Dövüş sporlarında güncel maçlar ve oranlarla hemen oyna, MMA iddaa keyfini yaşamaya başla!",
    },
    {
        "sayfa_adi": "BUZ HOKEYI",
        "path": "/iddaa/buz-hokeyi/tumu",
        "yeni_url": "/iddaa/buz-hokeyi",
        "oneri_notu": "-",
        "title": "Buz Hokeyi İddaa | İddaa Programı | Oley.com",
        "description": "Buz hokeyi iddaa heyecanı Oley’de! Canlı iddaa oyna, kazanmanın heyecanına ortak ol!",
    },
    {
        "sayfa_adi": "HENTBOL",
        "path": "/iddaa/hentbol/tumu",
        "yeni_url": "/iddaa/hentbol",
        "oneri_notu": "-",
        "title": "Hentbol İddaa | İddaa Programı | Oley.com",
        "description": "Hentbol iddaa heyecanı Oley.com'da seni bekliyor! Güncel maçlar ve oranlarla hemen oyna!",
    },
    {
        "sayfa_adi": "E-BASKETBOL",
        "path": "/iddaa/ebasketball/tumu",
        "yeni_url": "/iddaa/e-basketbol",
        "oneri_notu": "sayfa adı Türkçe → URL de Türkçe olmalı.",
        "title": "E-Basketbol İddaa Programı | Canlı Oyna-İzle | Oley.com",
        "description": "E-Basketbol ile iddaa heyecanı bambaşka! Sanal basketbol maçlarına hemen oyna, E-Basketbol keyfini canlı yayınlarla Oley’de yaşa.",
    },
    {
        "sayfa_adi": "BASKETBOL UZUN VADELI",
        "path": "/iddaa/basketbol/uzunvadeli",
        "yeni_url": "/iddaa/basketbol/uzun-vadeli",
        "oneri_notu": "Bitişik yazım okunabilirliği zorlaştırır. SEO'da kelime arası tire kullanımı önerilir.",
        "title": "Basketbol Uzun Vadeli | Uzun Vadeli Oyunlar | Oley.com",
        "description": "Basketbol uzun vadeli oyunları ile iddaa heyecanını yaşa! Bahisleri incele, sezonluk tahminlerini oluştur ve uzun vadeli iddaa kuponu yap!",
    },
    {
        "sayfa_adi": "VOLEYBOL UZUN VADELI",
        "path": "/iddaa/voleybol/uzunvadeli",
        "yeni_url": "/iddaa/voleybol/uzun-vadeli",
        "oneri_notu": "Bitişik yazım okunabilirliği zorlaştırır. SEO'da kelime arası tire kullanımı önerilir.",
        "title": "Voleybol Uzun Vadeli | Uzun Vadeli Oyunlar | Oley.com",
        "description": "Voleybol uzun vadeli oyunları ile sezon boyu iddaa heyecanı seni bekliyor. Oley.com'da Hemen Oyna!",
    },
    {
        "sayfa_adi": "BUZ HOKEYI UZUN VADELI",
        "path": "/iddaa/buz-hokeyi/uzunvadeli",
        "yeni_url": "/iddaa/buz-hokeyi/uzun-vadeli",
        "oneri_notu": "Bitişik yazım okunabilirliği zorlaştırır. SEO'da kelime arası tire kullanımı önerilir.",
        "title": "Buz Hokeyi Uzun Vadeli | Uzun Vadeli Oyunlar | Oley.com",
        "description": "Buz hokeyi uzun vadeli oyunları ile iddaa heyecanını uzun vadeye taşı. Bahisleri incele, sezonluk tahminlerini Oley’de yap.",
    },
    {
        "sayfa_adi": "HENTBOL UZUN VADELI",
        "path": "/iddaa/hentbol/uzunvadeli",
        "yeni_url": "/iddaa/hentbol/uzun-vadeli",
        "oneri_notu": "Bitişik yazım okunabilirliği zorlaştırır. SEO'da kelime arası tire kullanımı önerilir.",
        "title": "Hentbol Uzun Vadeli | Uzun Vadeli Oyunlar | Oley.com",
        "description": "Hentbol uzun vadeli oyunları ile iddaa heyecanını sezon boyunca yaşa. Bahis seçeneklerini incele, tahminini yap!",
    },
    {
        "sayfa_adi": "ÜYELIK BILGILERIM",
        "path": "/hesabim/uyelik",
        "title": "Üyelik Bilgilerim | Hesap Ayarları | Oley.com",
        "description": "Üyelik bilgilerini görüntüle, hesap ayarlarını güncelle ve Oley hesabını güvenle yönet. Tüm üyelik detayların bu sayfada.",
    },
    {
        "sayfa_adi": "SPOR TOTO KUPONLARIM",
        "path": "/hesabim/spor-toto/devam-edenler",
        "title": "Devam Eden Spor Toto Oyunları | Oley.com",
        "description": "Devam eden Spor Toto kuponlarını görüntüle, aktif kuponlarını takip et.",
    },
    {
        "sayfa_adi": "PIYANGO BILETLERIM",
        "path": "/hesabim/esya-piyangosu/devam-eden-cekilisler",
        "title": "Devam Eden Eşya Piyangosu Çekilişleri | Oley.com",
        "description": "Devam eden eşya piyangosu çekilişlerini takip et, aktif katılımlarını görüntüle. Çekiliş heyecanını Oley.com'da Yaşa!",
    },
    {
        "sayfa_adi": "OYNA KAZAN KARTLARIM",
        "path": "/hesabim/oyna-kazan/kartlarim",
        "title": "Kartlarım | Oyna Kazan | Oley.com",
        "description": "Oyna Kazan kartlarını görüntüle, aktif ve kullanılan kartlarını takip et. Oley’de heyecan ve kazanç bir arada.",
    },
    {
        "sayfa_adi": "HESAP HAREKETLERIM",
        "path": "/hesabim/hesap-hareketlerim",
        "title": "Hesap Hareketlerim | Para Giriş Çıkışları | Oley.com",
        "description": "Para yatırma ve çekme işlemleri dahil tüm hesap hareketlerini detaylı olarak incele. ",
    },
    {
        "sayfa_adi": "DESTEK TALEPLERIM",
        "path": "/hesabim/destek-taleplerim/beklemede",
        "title": "Beklemedeki Destek Taleplerim | Oley.com",
        "description": "Beklemede olan destek taleplerini görüntüle, taleplerinin durumunu kolayca takip et. Oley.com destek ekibi seninle.",
    },
    {
        "sayfa_adi": "İDDAA OYUN KURALLARI",
        "path": "/sozlesmeler/iddaa-oyun-kurallar",
        "title": "İddaa Oyun Kuralları | Oley.com",
        "description": "İddaa oyun kuralları, bahis şartları, geçerli kuponlar ve resmi uygulamalar hakkında tüm detaylara Oley.com üzerinden ulaşabilirsiniz.",
    },
    {
        "sayfa_adi": "PARA YATIR",
        "path": "/hesabim/para-yatir",
        "title": "Para Yatırma | Hesabım | Oley.com",
        "description": "Para yatırma işlemlerinizi kolayca yapabilir, hesabım alanından görüntüleyebilirsiniz.",
    },
    {
        "sayfa_adi": "PARA ÇEK",
        "path": "/hesabim/para-cek",
        "title": "Para Çekme | Hesabım | Oley.com ",
        "description": "Para çekme işlemlerinizi kolayca yapabilir, hesabım alanından görüntüleyebilirsiniz.",
    },
    {
        "sayfa_adi": "MASA TENISI",
        "path": "/iddaa/masa-tenisi/tumu",
        "yeni_url": "/iddaa/masa-tenisi/",
        "oneri_notu": "- tümü kaldırılabilir",
        "title": "Masa Tenisi İddaa | İddaa Programı | Oley.com",
        "description": "Masa Tenisi iddaa heyecanı Oley.com'da seni bekliyor! Güncel maçlar ve oranlarla hemen oyna!",
    }
];
